/* eslint-disable */

import Vue from 'vue'
import store from '@/store/store.js'
import Router from 'vue-router'
const Login = () => import('@/components/Login.vue')
const TrainingCourse = () => import('@/components/TrainingCourse/Index.vue')
const ViewUser = () => import('@/components/ViewUser/Index.vue')
const EditUser = () => import('@/components/Users/EditUser.vue')
const Builder = () => import('@/components/Admin/Builder.vue')
const Users = () => import('@/components/Users/Index.vue')
const Signature = () => import('@/components/Admin/Signature.vue')
const Checklist = () => import('@/components/Users/Checklist.vue')
const ReviewAnswers = () => import('@/components/TrainingCourse/ReviewAnswers.vue')
const ChecklistView = () => import('@/components/TrainingCourse/ChecklistView.vue')
const Logs = () => import('@/components/Admin/Logs.vue')
const ContactUs = () => import('@/components/ContactUs.vue')


Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Tologin',
      component: Login
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/reviewAnswers',
      name: 'reviewAnswers',
      component: ReviewAnswers,
      meta: {requiresAuth: 'user'}
    },
    {
      path: '/viewChecklist',
      name: 'viewChecklist',
      component: ChecklistView,
      meta: {requiresAuth: 'user'}
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: ContactUs,
      meta: {requiresAuth: 'user'}
    },
    {
      path: '/trainingCourse',
      name: 'trainingCourse',
      component: TrainingCourse,
      meta: {requiresAuth: 'user'}
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      //meta: {requiresAuth: 'admin', requiresAuth: 'trainer'}
      //meta: {requiresAuth: 'admin'}
      meta: {requiresAuth: 'trainer'}
    },
    {
      path: '/logs',
      name: 'logs',
      component: Logs,
      meta: {requiresAuth: 'admin'}
    },
    {
      path: '/builder',
      name: 'builder',
      component: Builder,
      meta: {requiresAuth: 'admin'}
    },
    {
      path: '/users/:userId',
      name: 'user',
      component: ViewUser,
      meta: {requiresAuth: 'admin'}
    },
    {
      path: '/users/:userId/edit',
      name: 'user-edit',
      component: EditUser,
      //meta: {requiresAuth: 'admin', requiresAuth: 'trainer'}
      //meta: {requiresAuth: 'admin'}
      meta: {requiresAuth: 'trainer'}
    },
    {
      path: '/users/:userId/edit/checklist',
      name: 'checklist',
      component: Checklist,
      meta: {requiresAuth: 'trainer'}
    },
    {
      path: '/signature',
      name: 'signature',
      component: Signature,
      meta: {requiresAuth: 'trainer'}
    }  
  ]
})

router.beforeEach((to, from, next) => {
  if (to.name === 'login') {
    if (store.state.isAdminLoggedIn || store.state.isTrainerLoggedIn) {
      next({name: 'users'})
    } else if (store.state.isUserLoggedIn) {
      next({name: 'trainingCourse'})
    } else {
      next()
    }
  }
  else if (to.meta.requiresAuth === 'user') {
    let authUser = store.state.isUserLoggedIn
    if (authUser) {
      next()
    } else {
      next({name: 'login'})
    }
  }
  else if (to.meta.requiresAuth === 'admin') {
    let authAdmin = store.state.isAdminLoggedIn
    if (authAdmin) {
      next()
    } else {
      next({name: 'login'})
    }
  }
  else if (to.meta.requiresAuth === 'trainer') {
    let authAdmin = store.state.isAdminLoggedIn
    let authTrainer = store.state.isTrainerLoggedIn
    if (authAdmin || authTrainer) {
      next()
    } else {
      next({name: 'login'})
    }
  }
  // may not be needed
  else {
    next()
  }
})
export default router
